import React from 'react';

type CancelIconSize = '12' | '16' | '24';

export interface SlCancelIconProps {
  color: string;
  size: CancelIconSize;
}

export const SlCancelIcon = ({ color, size }: SlCancelIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id=" &#226;&#134;&#179;color">
        <path
          id="vector 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9995 24C18.6269 24 23.9995 18.6274 23.9995 12C23.9995 5.37258 18.6269 0 11.9995 0C5.37209 0 -0.000488281 5.37258 -0.000488281 12C-0.000488281 18.6274 5.37209 24 11.9995 24Z"
          fill={color}
        />
        <path
          id="vector 2"
          d="M14.8285 9.17554L9.17164 14.8324"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          id="vector 1"
          d="M9.17163 9.17554L14.8285 14.8324"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
